// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/image/pricing-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/image/inner-banner-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @font-face {
    font-family: 'Roca Two';
    src: url('../font/roca-two/RocaTwo-Bold.woff2') format('woff2'),
        url('../font/roca-two/RocaTwo-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
} */
body {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: 'Open Sans', sans-serif;
}

html {
    scroll-behavior: smooth;
}

.container {
    margin: 0 auto;
}

.container-fluid {
    margin: 0 auto;
}

.header-menu .menubar {
    display: flex;
    background: #fff;
    box-shadow: 0px 3px 6px #00000040;
    height: 85px;
    align-items: center;
}

.menubar .logo {
    display: flex;
    align-items: center;
}

a:focus-visible {
    outline: none !important;
}

.menubar .but-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.navbar-nav .nav-item a {
    font-size: 16px;
    font-weight: 500;
    color: #241C15 !important;
}

.menubar ul.navbar-nav {
    display: flex;
    justify-content: space-between !important;
    width: 80%;
}

.menubar .but-right a.login {
    height: 40px;
    width: 120px;
    border: 1px solid #4CCD8D;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    color: #4CCD8D;
    font-weight: 500;
    margin-right: 5px;
    transition: 0.5s;
}

.menubar .but-right a.trail {
    background-color: #4CCD8D;
    height: 40px;
    width: 120px;
    border: 1px solid #4CCD8D;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    color: #fff;
    margin-left: 5px;
    transition: 0.5s;
}

.menubar .but-right a.login:hover {
    box-shadow: 0px 2px 0px #4CCD8D;
}

.menubar .but-right a.trail:hover {
    box-shadow: 0px 2px 0px #00000087;
}

a:hover {
    text-decoration: none !important;
}

.menubar .logo a {
    color: #548CFF;
    font-size: 24px;
    font-weight: 500;
}

.main-footer .footer-logo h2 {
    font-size: 42px;
}

.footer-page p {
    font-size: 16px;
    color: #2E2E2E;
    font-weight: 500;
}

.main-footer li {
    list-style: none;
}

.main-footer ul {
    padding-left: 0;
}

.main-footer ul.social-icon {
    display: flex;
    justify-content: space-between;
    width: 75%;
    margin-top: 32px;
}

.main-footer .social-icon a i {
    border: 1px solid #548CFF;
    padding: 9px;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    color: #000000c4;
    font-size: 19px;
}

.footer-page a {
    color: #1A1D84;
    font-size: 15px;
    line-height: 24.51px;
    font-weight: 500;
    text-decoration: none !important;
}

.main-footer .footer-page ul {
    padding-left: 0;
    column-count: 2;
}

.main-footer {
    background-color: #F6FAFF;
    padding: 30px 0 22px 0;
}

.main-footer .copywrite {
    margin-top: 2px;
    text-align: center;
}

.main-footer .footer-page li {
    margin-bottom: 15px;
}

.banner-content h2 {
    font-size: 45px;
    margin-bottom: 20px;
    line-height: 54px;
    font-family: 'Roca Two';
}

.banner-content p {
    font-size: 20px;
    line-height: 36.5px;
}

.banner-content .green-btn a {
    background-color: #4CCD8D;
    padding: 16px 75px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    border-radius: 5px;
    transition: 0.5s;
}

.banner-content .green-btn a:hover {
    box-shadow: 0px 2px 0px #000000a3;
}

.banner-content .green-btn {
    margin-top: 40px;
    margin-bottom: 20px;
}

.banner-content {
    text-align: center;
    width: 100%;
}

.main-banner {
    padding: 4rem 0;
}

.main-banner.pricing-banner {
    padding-bottom: 0;
}

.three-card .card {
    position: relative;
    border: none;
    overflow: hidden;
}

.card-text span {
    font-weight: 600;
}

.card h2 {
    font-size: 28px;
    position: absolute;
    top: 54px;
    left: 28px;
    z-index: 9;
    font-family: 'Roca Two';
}

.three-card .card-text button {
    border: none;
    color: #1A1D84;
    background-color: transparent;
    font-size: 18px;
    font-weight: 500;
    padding: 0;
}

.three-card p {
    margin-bottom: 3px;
    font-size: 18px;
}

.three-card .card-text {
    background-color: #C0DDF7;
    padding: 24px;
    position: absolute;
    bottom: 0;
    left: 0;
}

.three-card .card-box {
    position: relative;
}

.three-card .center-card .card-text {
    background-color: #ECFCF3;
}

.three-card .card-box img {
    height: 672px;
    object-fit: cover;
    transition: 0.3s;
}

.three-card .card-box img:hover {
    transform: scale(1.1);
}

.sec-head h3.roco-font {
    font-size: 36px;
    font-family: 'Roca Two';
}

.sec-head p {
    font-size: 20px;
}

.sec-head {
    margin-bottom: 70px;
    text-align: center;
}

.stap .num {
    font-size: 35px;
}

.stap h3 {
    font-size: 35px;
    line-height: 44px;
}

.stap p {
    font-size: 20px;
}

.how-to-work .three-step {
    display: flex;
    align-items: center;
}

.how-to-work .images img {
    width: 90%;
}

.how-to-work .step-arrow img {
    width: 54%;
}

.how-to-work .step-arrow {
    text-align: center;
}

.how-to-work {
    padding: 4rem 0;
}

.simple-pricing .sec-head {
    margin-bottom: 30px;
}

.yearly h4 {
    font-size: 25px;
}

.start span.amt {
    font-size: 20px;
    text-decoration-line: line-through;
}

.start span.off {
    font-size: 14px;
    border-radius: 3px;
}

.amount h2 {
    font-size: 35px;
}

.yearly .start-btn a {
    margin: 20px;
    background-color: #4CCD8D;
    display: flex;
    height: 62px;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    border-radius: 5px;
}

.yearly .amount {
    margin-bottom: 32px;
}

.simple-pricing .yearly {
    padding: 36px 22px;
}

.simple-pricing::before {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    top: 54%;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    background-repeat: no-repeat;
}

.simple-pricing {
    position: relative;
    padding-bottom: 4rem;
}

.about-image img.main-img-card {
    width: 100%;
}

.about-content h2 {
    font-size: 34px;
    /* font-family: 'Roca Two'; */
}

.about-content h3 {
    font-size: 45px;
    line-height: 52px;
}

.about-content p {
    font-size: 18px;
}

.about-image .prod {
    width: 178px;
    height: 65px;
}

.about-image .prod div {
    font-size: 13px;
    font-weight: 600;
}

.about-image .prod p {
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 7px;
}

.about-image .prod img {
    margin-right: 10px;
}

.about-us .about-image {
    width: 88%;
}

.about-us .top-card {
    right: -38px;
    top: 46px;
}

.btm-card .smail p {
    font-size: 13px;
    font-weight: 600;
}

.about-us .btm-card .smail {
    width: 126px;
    height: 34px;
    top: 5px;
    left: 37px;
}

.about-us .btm-card {
    position: absolute;
    bottom: 48px;
    right: -38px;
}

.about-us {
    padding: 5rem 0;
}


@keyframes float {
    0% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }

    50% {
        box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
        transform: translatey(-20px);
    }

    100% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
}

.about-us .avatar {
    box-sizing: border-box;
    transform: translatey(0px);
    animation: float 6s ease-in-out infinite;
}

.nonprofit .green-btn a {
    background-color: #4CCD8D;
    padding: 16px 75px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    border-radius: 5px;
}

.nonprofit .green-btn {
    text-align: center;
}

.nonprofit {
    padding: 3rem 15px;
}

.tasti .reymond img {
    width: 180px;
    height: 180px;
    margin: auto;
}

.reymond h2 {
    font-size: 30px;
}

.tasti-slide .reymond {
    text-align: center;
    /* padding-bottom: 72px; */
}

.tasti .text p {
    width: 80%;
    margin: auto;
    font-size: 20px;
}

.tasti .text img.left {
    width: 105px;
    height: auto;
    position: absolute;
    top: -55px;
    left: 76px;
}

.tasti .text img.right {
    width: 105px;
    height: auto;
    position: absolute;
    top: 33px;
    right: 50px;
}

.tasti .sec-head {
    margin-bottom: 15px;
}

.tasti .tasti-slide button.slide-arrow {
    border: none;
    width: 50px;
    height: 50px;
    background-color: #1A1D84;
    border-radius: 50px;
}

.tasti .tasti-slide button.prev-arrow {
    position: absolute;
    top: 52px;
    left: 66px;
}

.tasti .tasti-slide button.next-arrow {
    position: absolute;
    top: 52px;
    right: 66px;
}

.tasti {
    padding-top: 4rem;
}

button:focus-visible {
    outline: none !important;
}

button:focus {
    outline: none !important;
}

.get-in-touch .sec-head {
    margin-bottom: 40px;
    text-align: inherit;
}

.contect li {
    margin-bottom: 18px;
    display: flex;
    align-items: center;
}

.contect ul {
    padding-left: 0;
    column-count: 2;
}

.get-in-touch .contect i {
    font-size: 21px;
    width: 29px;
    text-align: center;
}

.get-in-touch .contect i.fa.fa-mobile {
    font-size: 28px;
}

.contact-form h2 {
    font-size: 40px;
    color: #2E2E2E;
    margin-bottom: 30px;
}

.contact-form .form-group input::placeholder {
    color: #696868;
}

.contact-form .form-group textarea::placeholder {
    color: #696868;
}

textarea {
    resize: none !important;
}

.contact-form button.submit-btn {
    font-size: 20px;
}

.get-in-touch .contact-form {
    padding: 40px;
    width: 100%;
    top: 140px;
    position: relative;
}

.get-in-touch .form-sec {
    display: flex;
    align-items: end;
    justify-content: end;
}

.get-in-touch .cont-desc {
    margin-top: 145px;
}

input:focus-visible {
    outline: none !important;
}

input:focus {
    outline: none !important;
}

textarea:focus-visible {
    outline: none !important;
}

textarea:focus {
    outline: none !important;
}

.inner-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 378px;
    background-size: cover;
    width: 100%;
    object-fit: cover;
    display: flex;
    align-items: center;
    justify-content: center;
}

.inner-banner h2 {
    font-size: 52px;
    font-weight: 600;
    color: #fff;
}

.faq-acc .accordion .card-header:after {
    font-family: 'FontAwesome';
    content: "\\f068";
    float: right;
    color: #479AE8;
}

.faq-acc .accordion .card-header.collapsed:after {
    content: "\\f067";
    color: #548CFF;
}

.inner-head h2 {
    font-size: 38px;
    font-weight: 600;
    margin-bottom: 15px;
}

.accordion .card-header {
    background-color: transparent;
    cursor: pointer;
    position: relative;
}

.faq-acc .accordion .card {
    border: none;
}

.faq-acc .faqs a.card-title {
    font-size: 20px;
}

.faq-acc .faqs .card-body {
    font-size: 18px;
}

.faq-acc {
    padding: 5rem 0;
}

.condition .cards-head p {
    font-size: 20px;
    border-radius: 5px;
    margin-bottom: 42px;
}

.condition .cards h3 {
    font-size: 25px;
    font-weight: 600;
    margin-bottom: 10px;
}

.condition .cards p {
    font-size: 18px;
}

.condition .cards {
    border-radius: 3px;
    margin-bottom: 20px;
}

.condition ul .cards p {
    margin-bottom: 4px;
}

.cards ul {
    padding-left: 0;
}

.condition {
    padding: 4rem 0;
}

.get-start h2 {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 7px;
    color: #3C3C3C;
}

.get-start h3 {
    font-size: 24px;
    margin-bottom: 8px;
    font-weight: 400;
}

.get-start p {
    font-size: 18px;
    color: #4D4D4D;
}

.registration .rigester-box {
    background-color: #fff;
    width: 100%;
    padding: 70px 30px;
    border-radius: 20px;
    margin: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.stapper-box .select-btn.stpe-three button {
    padding: 6px 36px;
}

.registration {
    background-color: #f2f2f7;
    padding: 2rem;
    height: 100vh;
    display: flex;
    align-items: center;
}

.rigester-box .input-box a {
    border: 1px solid #636060;
    width: 100%;
    display: flex;
    height: 50px;
    align-items: center;
    margin-bottom: 22px;
    border-radius: 7px;
    color: #4A5057;
    font-size: 17px;
    font-weight: 600;
    padding: 0 122px;
}

.input-box a img {
    margin-right: 14px;
}

.rigester-box .next {
    position: relative;
    margin-top: 32px;
    margin-bottom: 32px;
}

.rigester-box .next h2 {
    font-size: 25px;
    font-weight: 400;
    margin-bottom: 0;
    text-align: center;
    position: absolute;
    top: 0px;
    left: 45%;
    background-color: #fff;
    padding: 0 8px;
    right: 45%;
}

.rigester-box .sign-up input {
    width: 79%;
    height: 50px;
    border: 1px solid #4CCD8D;
    border-radius: 7px;
    padding-left: 15px;
}

.rigester-box .sign-up {
    position: relative;
}

.check p {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0;
    color: #484848d4;
}

.rigester-box .check {
    display: flex;
    align-items: center;
    margin-top: 32px;
}

.check a {
    color: #484848;
    font-weight: 600;
}

.rigester-box .get-start {
    text-align: center;
}

.get-start span {
    font-weight: 600;
}

.rigester-box .open-box a {
    border: 1px solid #636060;
    display: flex;
    height: 64px;
    align-items: center;
    border-radius: 7px;
    color: #636060;
    font-size: 18px;
    font-weight: 400;
    padding: 0 15px;
}

.stapper-box h2 {
    font-size: 22px;
    color: #232323;
    font-weight: 400;
    margin-bottom: 12px;
    text-align: center;
}

.stapper-box h3 {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    color: #232323;
}

.stapper-box .select-btn button {
    border: 1px solid #00000059;
    background-color: transparent;
    border-radius: 29px;
    padding: 6px 24px;
    margin: 8px 3px;
    font-size: 14px;
    color: #313131;
    font-weight: 500;
}

.stapper-box .select-btn {
    margin-top: 40px;
    text-align: center;
}

.stapper-box .next-step {
    position: absolute;
    top: -7.7rem;
}

.next-step p {
    color: #707070;
    font-size: 16px;
}

.stapper-box button.next-btn {
    background-color: #4CCD8D;
    height: 43px;
    width: 120px;
    border: 1px solid #4CCD8D;
    color: #fff;
    transition: 0.5s;
    text-transform: capitalize;
    font-size: 18px;
}

.stapper-box button.back-btn {
    background-color: transparent;
    height: 43px;
    width: 120px;
    border: 1px solid #4CCD8D;
    color: #00000091;
    transition: 0.5s;
    text-transform: capitalize;
    font-size: 18px;
}

.stapper-box span svg.MuiSvgIcon-root {
    width: 35px;
    height: 35px;
}

.get-start-login h2 {
    font-size: 32px;
    font-weight: 600;
}

.get-start-login p {
    font-size: 20px;
}

.tasti-slide .slick-next:before,
.tasti-slide .slick-prev:before {
    color: #fff;
    opacity: 1;
    font-family: inherit;
    font-size: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 3px;
}

.tasti-slide button.slick-arrow {
    background-color: #1A1D84;
    width: 46px;
    height: 46px;
    border-radius: 50px;
}

.login .get-start-login a {
    color: #000;
    font-weight: 600;
}

.login .form-group label {
    font-size: 17px;
    color: #4A5057;
    margin-bottom: 2px;
}

.login .form-group input {
    border: 1px solid #ccc;
    width: 100%;
    display: flex;
    height: 42px;
    border-radius: 7px;
    color: #4a5057ad;
    font-size: 16px;
    font-weight: 500;
    padding: 14px;
}

.forget a {
    color: #548CFF;
    font-weight: 500;
}

.stapper-box .select-btn.stpe-three {
    width: 80%;
    margin: 34px auto 0;
}

.stapper-box .MuiBox-root.css-hsr0i9 {
    padding-top: 50px;
}

.forget {
    text-align: end;
}

.login.rigester-box .check {
    margin-top: 4px;
}

.login .sec-btns a {
    background-color: #4CCD8D;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    border-radius: 5px;
    border: none;
    width: 300px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.rigester-box.login .input-box {
    margin: auto;
    width: 300px;
}

.rigester-box.login .input-box a {
    padding: 0 26px;
}

.sending-mess p {
    color: #4A5057;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 2px;
}

.sending-mess {
    margin-top: 26px;
    text-align: center;
}

.mail-box .sec-btns a {
    background-color: #4CCD8D;
    color: #fff;
    font-size: 18px;
    border-radius: 5px;
    border: none;
    width: 300px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mail-box img {
    width: 116px;
    margin-bottom: 15px;
}

.mail-box .get-start-login {
    text-align: center;
}

.dashfaq .accordion .card-header.collapsed:after {
    content: "❯";
    font-size: 20px;
    transform: rotate(360deg);
    transition: all 0.35s ease 0s;
    position: absolute;
    right: 12px;
    top: 10px;
    color: #548CFF;
}

.dashfaq .accordion .card-header:after {
    content: "❯";
    font-size: 20px;
    transform: rotate(90deg);
    transition: all 0.35s ease 0s;
    position: absolute;
    right: 12px;
    top: 10px;
    color: #548CFF;
}

.dashfaq .card-header,
.dashfaq .faqs .card-body {
    padding-left: 0;
    padding-right: 0;
}

.dashfaq .faq-acc {
    padding: 0;
}

.dashfaq .sec-head {
    text-align: left;
}

.dashfaq {
    padding: 5rem 0;
}

.faq-acc a.see {
    color: #2E2E2E;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    justify-content: end;
    margin-top: 22px;
}

.react-switch-bg .year {
    right: 18px;
    position: absolute;
    color: #fff;
    top: 4px;
}

.react-switch-bg .mont {
    left: 9px;
    position: absolute;
    color: #fff;
    top: 4px;
}

.react-switch-handle {
    width: 28px !important;
    height: 28px !important;
    top: 3px !important;
    left: 3px;
}

.pricing-table table {
    width: 100%;
}

.pricing-table h3 {
    font-size: 24px;
}

.pricing-table p {
    color: #696868;
    font-size: 14px;
    font-weight: 400;
}

.plan button {
    color: #4CCD8D;
    border: 1px solid;
    background-color: transparent;
    width: 180px;
    height: 50px;
    border-radius: 5px;
    margin-top: 22px;
}

.pricing-table .plan {
    width: 90%;
}

.pricing-table .yearly .start-btn a {
    width: 180px;
    height: 50px;
    margin-top: 0;
    font-weight: 400;
    font-size: 18px;
}

.pricing-table .yearly .start-btn {
    margin-top: 18px;
    display: flex;
    justify-content: center;
}

.pricing-table table th.w-250px {
    padding: 20px 16px 0px 16px;
    border: 1px solid #00000040;
    width: 250px;
}

.pricing-table .amount h2 {
    font-size: 31px;
    margin-top: 13px;
}

.pricing-table table td {
    padding: 13px;
    border: 1px solid #00000040;
    color: #363853;
}

.pricing-table .table-sec {
    padding: 12px;
    text-align: center;
    color: #696868;
    font-size: 18px;
    font-weight: 500;
}

.pricing-table td span {
    border-bottom: 1px solid #2E2E2E;
    border-block-style: dotted;
    border-top: 0;
    color: #696868;
}

.pricing-table th.top-fixed {
    /* position: sticky; */
    top: 85px;
    background: #fff;
}

#masthead.back {
    position: fixed;
    z-index: 99999;
    width: 100%;
    top: 0px;
    left: 0px;
    background: #fff;
    box-shadow: 0px 0px 10px #ccc;
    animation: animate forwards 1s;
}

.rigester-box .sign-up a {
    height: 50px;
    border: none;
    top: 0;
    background-color: #4CCD8D;
    width: 150px;
    position: absolute;
    right: 0;
    border-radius: 7px;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
    align-items: center;
    display: flex;
    justify-content: center;
}

.sucess-modal .next-btn a {
    background-color: #4ccd8d;
    color: #fff;
    padding: 12px 74px;
    font-size: 18px;
    border-radius: 5px;
}

.sucess-modal .next-btn {
    text-align: center;
    margin-top: 46px;
}

.sucess-image img {
    width: 203px;
}

.stapper-box .select-btn button.active {
    background-color: #4ccd8d;
    border: 1px solid #4ccd8d;
    color: #fff;
}

.stapper-box .MuiBox-root span.MuiStepLabel-label {
    display: none;
}

.registration .logo h2 {
    text-align: center;
    margin-bottom: 26px;
    font-size: 36px;
}

.left-sec .get-start {
    text-align: center;
    width: 86%;
    margin: 0;
}

.registration .left-sec {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.statistics-sec {
    padding: 0 0 6rem 0;
}

.statistics-sec h3 {
    font-size: 36px;
    font-family: 'Roca Two';
    text-align: center;
    margin-bottom: 3rem;
}

.stats-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.stats-container .stats-count {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stats-container .stats-count h2{
    color: #4ccd8d;
    font-size: 50px;
    font-weight: 600;
}

.stats-container .mid-count{
    border-right: 2px solid #4ccd8d;
    border-left: 2px solid #4ccd8d;
}


@keyframes animate {
    0% {
        top: -100px;
    }

    100% {
        top: 0px;
    }
}


/* =====responsive====== */

@media (max-width:1366px) {}

@media (max-width:1280px) {
    .menubar .logo a {
        font-size: 22px;
    }
    .rigester-box .input-box a {
        padding: 0 100px;
    }
}

@media (max-width:2048px) {}

@media (max-width:1080px) {
    .menubar .logo {
        padding-right: 0;
    }

    .menubar .logo a {
        font-size: 20px;
    }
}

@media (max-width:1024px) {
    .navbar-nav .nav-item a {
        font-size: 15px;
    }

    .menubar .logo a {
        font-size: 18px;
    }
}

@media (max-width:990px) {
    .header-menu .sec-center {
        position: relative;
    }

    .page button.navbar-toggler {
        position: absolute;
        right: 0;
        top: 10px;
    }

    div#navbarNavDropdown {
        position: absolute;
        top: 56px;
        width: 100vw;
        right: -15px;
        z-index: 1;
        box-shadow: 0 9px 10px 0px #d5d1d1;
        background-color: #fff;
        padding: 16px 16px 45px 18px;
    }

    .page .nav-pages {
        width: 100%;
        min-width: 100%;
    }

    .page .but-right {
        justify-content: flex-start;
        margin-top: 20px;
    }

    .menubar .logo a {
        width: 201px;
        display: flex;
        font-size: 22px;
    }

    .page button.navbar-toggler {
        top: -3px;
    }

    .page .but-right {
        margin-left: 16px;
    }

    .get-in-touch .contact-form {
        padding: 30px;
        /* width: 95%; */
    }

}

@media (max-width:767px) {
    .banner-content h2 {
        font-size: 32px;
        line-height: 42px;
    }

    .banner-content p {
        font-size: 16px;
        line-height: inherit;
    }

    .banner-content .green-btn a {
        padding: 13px 66px;
        font-size: 16px;
    }

    .three-card .card-box {
        margin-bottom: 30px;
    }

    .sec-head h3.roco-font {
        font-size: 32px;
    }

    .sec-head p {
        font-size: 16px;
        line-height: inherit !important;
    }

    .stap .num {
        font-size: 32px;
    }

    .stap h3 {
        font-size: 28px;
        line-height: 39px;
    }

    .stap p {
        font-size: 16px;
        line-height: inherit !important;
    }

    .how-to-work .step-arrow img {
        display: none;
    }

    .how-to-work .images img {
        width: 100%;
    }

    .simple-pricing .yearly {
        margin-bottom: 30px;
    }

    .how-to-work .step-arrow {
        margin-bottom: 30px;
    }

    .get-in-touch .contact-form {
        padding: 36px 24px;
        width: 100%;
        position: initial;
    }

    .get-in-touch {
        margin-bottom: 4rem;
    }

    .tasti-slide button.slick-arrow {
        width: 38px;
        height: 38px;
        border-radius: 50px;
        top: 80px;
    }

    .tasti .text p {
        font-size: 16px;
    }

    .tasti .text img.left {
        width: 60px;
        position: absolute;
        top: -8px;
        left: 0px;
    }

    .tasti .text img.right {
        width: 60px;
        position: absolute;
        top: 162px;
        right: 0;
    }

    .tasti .slick-prev {
        left: 0;
    }

    .tasti .slick-next {
        right: 0;
    }

    .about-content h3 {
        font-size: 28px;
        line-height: initial;
    }

    .about-content p {
        font-size: 16px;
    }

    .about-us {
        padding-top: 0;
    }

    .contact-form h2 {
        font-size: 32px;
        margin-bottom: 32px;
    }

    .main-footer .footer-logo h2 {
        font-size: 36px;
    }

    .main-footer .footer-page ul {
        padding-left: 15px;
        column-count: 1;
        margin-top: 10px;
    }

    .main-footer .footer-page li {
        margin-bottom: 14px;
    }

    .header-menu nav.navbar {
        padding: 0;
    }

    .page button.navbar-toggler {
        top: -36px;
        padding: 2px 7px;
    }

    div#navbarNavDropdown {
        top: 18px;
    }

    .registration {
        height: auto;
        padding: 2rem 0;
    }

    .registration .logo h2 {
        margin-bottom: 16px;
        font-size: 32px;
    }

    .get-start h2 {
        font-size: 28px;
    }

    .rigester-box.login .input-box a {
        padding: 0 19px;
        font-size: 16px;
        height: 45px;
    }

    .rigester-box.login .input-box {
        width: 100%;
    }

    .login .sec-btns a {
        width: 100%;
        height: 45px;
    }

    .mail-box .sec-btns a {
        height: 45px;
        width: 100%;

    }

    .rigester-box .input-box a {
        padding: 11px;
        height: 45px;
    }

    .get-start h3 {
        font-size: 22px;
    }

    .rigester-box .sign-up a {
        height: 50px;
        width: 105px;
        font-size: 16px;
        height: 45px;
    }

    .rigester-box .sign-up input {
        width: 79%;
        height: 45px;
    }

    .rigester-box .next h2 {
        font-size: 18px;
        top: 4px;
        left: 43%;
    }

    .rigester-box .open-box a {
        height: 50px;
        margin-bottom: 20px;
    }

    .get-start p {
        font-size: 16px;
    }

    .stapper-box .select-btn.stpe-three {
        width: 100%;
    }

    .css-yefs0x-MuiPaper-root.sucess-modal {
        width: 95%;
    }

    .sucess-image img {
        width: 150px;
    }
}


.subscription_card {
    width: 280px;
    height: 400px;
    /* border: 1px solid #8e44ad; */
    transition: box-shadow 0.3s ease;
}

.subscription_card:hover {
    box-shadow: 0 0 20px 0 rgba(123, 241, 133, 0.7);
}

.cad-text-small {
    font-size: 13px !important;
}

.cad-text-medium {
    font-size: 15px !important;
}

.cad-text-large {
    font-size: 18px !important;
}

.cad-text-xlarge {
    font-size: 22px !important;

}

.cad-fw-100 {
    font-weight: 100 !important;
}

.cad-fw-400 {
    font-weight: 400 !important;
}

.cad-fw-500 {
    font-weight: 500 !important;
}


.cad-fw-600 {
    font-weight: 600 !important;
}

.cad-fw-700 {
    font-weight: 700 !important;
}

.cad-fw-800 {
    font-weight: 800 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;;;;GAOG;AACH;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yDAAyD;IACzD,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI;QACI,6CAA6C;QAC7C,0BAA0B;IAC9B;;IAEA;QACI,8CAA8C;QAC9C,4BAA4B;IAChC;;IAEA;QACI,6CAA6C;QAC7C,0BAA0B;IAC9B;AACJ;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yDAA8D;IAC9D,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,MAAM;IACN,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;;AAGA;IACI;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;AACJ;;;AAGA,0BAA0B;;AAE1B,2BAA2B;;AAE3B;IACI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA,2BAA2B;;AAE3B;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,UAAU;QACV,kCAAkC;QAClC,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;AAEJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,+BAA+B;IACnC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;;IAEf;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;;AAE9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,800&display=swap');\n\n/* @font-face {\n    font-family: 'Roca Two';\n    src: url('../font/roca-two/RocaTwo-Bold.woff2') format('woff2'),\n        url('../font/roca-two/RocaTwo-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n} */\nbody {\n    width: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    font-family: 'Open Sans', sans-serif;\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\n.container {\n    margin: 0 auto;\n}\n\n.container-fluid {\n    margin: 0 auto;\n}\n\n.header-menu .menubar {\n    display: flex;\n    background: #fff;\n    box-shadow: 0px 3px 6px #00000040;\n    height: 85px;\n    align-items: center;\n}\n\n.menubar .logo {\n    display: flex;\n    align-items: center;\n}\n\na:focus-visible {\n    outline: none !important;\n}\n\n.menubar .but-right {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.navbar-nav .nav-item a {\n    font-size: 16px;\n    font-weight: 500;\n    color: #241C15 !important;\n}\n\n.menubar ul.navbar-nav {\n    display: flex;\n    justify-content: space-between !important;\n    width: 80%;\n}\n\n.menubar .but-right a.login {\n    height: 40px;\n    width: 120px;\n    border: 1px solid #4CCD8D;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n    color: #4CCD8D;\n    font-weight: 500;\n    margin-right: 5px;\n    transition: 0.5s;\n}\n\n.menubar .but-right a.trail {\n    background-color: #4CCD8D;\n    height: 40px;\n    width: 120px;\n    border: 1px solid #4CCD8D;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n    color: #fff;\n    margin-left: 5px;\n    transition: 0.5s;\n}\n\n.menubar .but-right a.login:hover {\n    box-shadow: 0px 2px 0px #4CCD8D;\n}\n\n.menubar .but-right a.trail:hover {\n    box-shadow: 0px 2px 0px #00000087;\n}\n\na:hover {\n    text-decoration: none !important;\n}\n\n.menubar .logo a {\n    color: #548CFF;\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.main-footer .footer-logo h2 {\n    font-size: 42px;\n}\n\n.footer-page p {\n    font-size: 16px;\n    color: #2E2E2E;\n    font-weight: 500;\n}\n\n.main-footer li {\n    list-style: none;\n}\n\n.main-footer ul {\n    padding-left: 0;\n}\n\n.main-footer ul.social-icon {\n    display: flex;\n    justify-content: space-between;\n    width: 75%;\n    margin-top: 32px;\n}\n\n.main-footer .social-icon a i {\n    border: 1px solid #548CFF;\n    padding: 9px;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50px;\n    color: #000000c4;\n    font-size: 19px;\n}\n\n.footer-page a {\n    color: #1A1D84;\n    font-size: 15px;\n    line-height: 24.51px;\n    font-weight: 500;\n    text-decoration: none !important;\n}\n\n.main-footer .footer-page ul {\n    padding-left: 0;\n    column-count: 2;\n}\n\n.main-footer {\n    background-color: #F6FAFF;\n    padding: 30px 0 22px 0;\n}\n\n.main-footer .copywrite {\n    margin-top: 2px;\n    text-align: center;\n}\n\n.main-footer .footer-page li {\n    margin-bottom: 15px;\n}\n\n.banner-content h2 {\n    font-size: 45px;\n    margin-bottom: 20px;\n    line-height: 54px;\n    font-family: 'Roca Two';\n}\n\n.banner-content p {\n    font-size: 20px;\n    line-height: 36.5px;\n}\n\n.banner-content .green-btn a {\n    background-color: #4CCD8D;\n    padding: 16px 75px;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    border-radius: 5px;\n    transition: 0.5s;\n}\n\n.banner-content .green-btn a:hover {\n    box-shadow: 0px 2px 0px #000000a3;\n}\n\n.banner-content .green-btn {\n    margin-top: 40px;\n    margin-bottom: 20px;\n}\n\n.banner-content {\n    text-align: center;\n    width: 100%;\n}\n\n.main-banner {\n    padding: 4rem 0;\n}\n\n.main-banner.pricing-banner {\n    padding-bottom: 0;\n}\n\n.three-card .card {\n    position: relative;\n    border: none;\n    overflow: hidden;\n}\n\n.card-text span {\n    font-weight: 600;\n}\n\n.card h2 {\n    font-size: 28px;\n    position: absolute;\n    top: 54px;\n    left: 28px;\n    z-index: 9;\n    font-family: 'Roca Two';\n}\n\n.three-card .card-text button {\n    border: none;\n    color: #1A1D84;\n    background-color: transparent;\n    font-size: 18px;\n    font-weight: 500;\n    padding: 0;\n}\n\n.three-card p {\n    margin-bottom: 3px;\n    font-size: 18px;\n}\n\n.three-card .card-text {\n    background-color: #C0DDF7;\n    padding: 24px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n}\n\n.three-card .card-box {\n    position: relative;\n}\n\n.three-card .center-card .card-text {\n    background-color: #ECFCF3;\n}\n\n.three-card .card-box img {\n    height: 672px;\n    object-fit: cover;\n    transition: 0.3s;\n}\n\n.three-card .card-box img:hover {\n    transform: scale(1.1);\n}\n\n.sec-head h3.roco-font {\n    font-size: 36px;\n    font-family: 'Roca Two';\n}\n\n.sec-head p {\n    font-size: 20px;\n}\n\n.sec-head {\n    margin-bottom: 70px;\n    text-align: center;\n}\n\n.stap .num {\n    font-size: 35px;\n}\n\n.stap h3 {\n    font-size: 35px;\n    line-height: 44px;\n}\n\n.stap p {\n    font-size: 20px;\n}\n\n.how-to-work .three-step {\n    display: flex;\n    align-items: center;\n}\n\n.how-to-work .images img {\n    width: 90%;\n}\n\n.how-to-work .step-arrow img {\n    width: 54%;\n}\n\n.how-to-work .step-arrow {\n    text-align: center;\n}\n\n.how-to-work {\n    padding: 4rem 0;\n}\n\n.simple-pricing .sec-head {\n    margin-bottom: 30px;\n}\n\n.yearly h4 {\n    font-size: 25px;\n}\n\n.start span.amt {\n    font-size: 20px;\n    text-decoration-line: line-through;\n}\n\n.start span.off {\n    font-size: 14px;\n    border-radius: 3px;\n}\n\n.amount h2 {\n    font-size: 35px;\n}\n\n.yearly .start-btn a {\n    margin: 20px;\n    background-color: #4CCD8D;\n    display: flex;\n    height: 62px;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    font-size: 20px;\n    font-weight: 600;\n    border-radius: 5px;\n}\n\n.yearly .amount {\n    margin-bottom: 32px;\n}\n\n.simple-pricing .yearly {\n    padding: 36px 22px;\n}\n\n.simple-pricing::before {\n    content: \"\";\n    background-image: url(../src/assets/image/pricing-bg.png);\n    position: absolute;\n    top: 54%;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: -1;\n    background-repeat: no-repeat;\n}\n\n.simple-pricing {\n    position: relative;\n    padding-bottom: 4rem;\n}\n\n.about-image img.main-img-card {\n    width: 100%;\n}\n\n.about-content h2 {\n    font-size: 34px;\n    /* font-family: 'Roca Two'; */\n}\n\n.about-content h3 {\n    font-size: 45px;\n    line-height: 52px;\n}\n\n.about-content p {\n    font-size: 18px;\n}\n\n.about-image .prod {\n    width: 178px;\n    height: 65px;\n}\n\n.about-image .prod div {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.about-image .prod p {\n    font-weight: 600;\n    font-size: 12px;\n    margin-bottom: 7px;\n}\n\n.about-image .prod img {\n    margin-right: 10px;\n}\n\n.about-us .about-image {\n    width: 88%;\n}\n\n.about-us .top-card {\n    right: -38px;\n    top: 46px;\n}\n\n.btm-card .smail p {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.about-us .btm-card .smail {\n    width: 126px;\n    height: 34px;\n    top: 5px;\n    left: 37px;\n}\n\n.about-us .btm-card {\n    position: absolute;\n    bottom: 48px;\n    right: -38px;\n}\n\n.about-us {\n    padding: 5rem 0;\n}\n\n\n@keyframes float {\n    0% {\n        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);\n        transform: translatey(0px);\n    }\n\n    50% {\n        box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);\n        transform: translatey(-20px);\n    }\n\n    100% {\n        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);\n        transform: translatey(0px);\n    }\n}\n\n.about-us .avatar {\n    box-sizing: border-box;\n    transform: translatey(0px);\n    animation: float 6s ease-in-out infinite;\n}\n\n.nonprofit .green-btn a {\n    background-color: #4CCD8D;\n    padding: 16px 75px;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    border-radius: 5px;\n}\n\n.nonprofit .green-btn {\n    text-align: center;\n}\n\n.nonprofit {\n    padding: 3rem 15px;\n}\n\n.tasti .reymond img {\n    width: 180px;\n    height: 180px;\n    margin: auto;\n}\n\n.reymond h2 {\n    font-size: 30px;\n}\n\n.tasti-slide .reymond {\n    text-align: center;\n    /* padding-bottom: 72px; */\n}\n\n.tasti .text p {\n    width: 80%;\n    margin: auto;\n    font-size: 20px;\n}\n\n.tasti .text img.left {\n    width: 105px;\n    height: auto;\n    position: absolute;\n    top: -55px;\n    left: 76px;\n}\n\n.tasti .text img.right {\n    width: 105px;\n    height: auto;\n    position: absolute;\n    top: 33px;\n    right: 50px;\n}\n\n.tasti .sec-head {\n    margin-bottom: 15px;\n}\n\n.tasti .tasti-slide button.slide-arrow {\n    border: none;\n    width: 50px;\n    height: 50px;\n    background-color: #1A1D84;\n    border-radius: 50px;\n}\n\n.tasti .tasti-slide button.prev-arrow {\n    position: absolute;\n    top: 52px;\n    left: 66px;\n}\n\n.tasti .tasti-slide button.next-arrow {\n    position: absolute;\n    top: 52px;\n    right: 66px;\n}\n\n.tasti {\n    padding-top: 4rem;\n}\n\nbutton:focus-visible {\n    outline: none !important;\n}\n\nbutton:focus {\n    outline: none !important;\n}\n\n.get-in-touch .sec-head {\n    margin-bottom: 40px;\n    text-align: inherit;\n}\n\n.contect li {\n    margin-bottom: 18px;\n    display: flex;\n    align-items: center;\n}\n\n.contect ul {\n    padding-left: 0;\n    column-count: 2;\n}\n\n.get-in-touch .contect i {\n    font-size: 21px;\n    width: 29px;\n    text-align: center;\n}\n\n.get-in-touch .contect i.fa.fa-mobile {\n    font-size: 28px;\n}\n\n.contact-form h2 {\n    font-size: 40px;\n    color: #2E2E2E;\n    margin-bottom: 30px;\n}\n\n.contact-form .form-group input::placeholder {\n    color: #696868;\n}\n\n.contact-form .form-group textarea::placeholder {\n    color: #696868;\n}\n\ntextarea {\n    resize: none !important;\n}\n\n.contact-form button.submit-btn {\n    font-size: 20px;\n}\n\n.get-in-touch .contact-form {\n    padding: 40px;\n    width: 100%;\n    top: 140px;\n    position: relative;\n}\n\n.get-in-touch .form-sec {\n    display: flex;\n    align-items: end;\n    justify-content: end;\n}\n\n.get-in-touch .cont-desc {\n    margin-top: 145px;\n}\n\ninput:focus-visible {\n    outline: none !important;\n}\n\ninput:focus {\n    outline: none !important;\n}\n\ntextarea:focus-visible {\n    outline: none !important;\n}\n\ntextarea:focus {\n    outline: none !important;\n}\n\n.inner-banner {\n    background-image: url(../src/assets/image/inner-banner-bg.png);\n    height: 378px;\n    background-size: cover;\n    width: 100%;\n    object-fit: cover;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.inner-banner h2 {\n    font-size: 52px;\n    font-weight: 600;\n    color: #fff;\n}\n\n.faq-acc .accordion .card-header:after {\n    font-family: 'FontAwesome';\n    content: \"\\f068\";\n    float: right;\n    color: #479AE8;\n}\n\n.faq-acc .accordion .card-header.collapsed:after {\n    content: \"\\f067\";\n    color: #548CFF;\n}\n\n.inner-head h2 {\n    font-size: 38px;\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n.accordion .card-header {\n    background-color: transparent;\n    cursor: pointer;\n    position: relative;\n}\n\n.faq-acc .accordion .card {\n    border: none;\n}\n\n.faq-acc .faqs a.card-title {\n    font-size: 20px;\n}\n\n.faq-acc .faqs .card-body {\n    font-size: 18px;\n}\n\n.faq-acc {\n    padding: 5rem 0;\n}\n\n.condition .cards-head p {\n    font-size: 20px;\n    border-radius: 5px;\n    margin-bottom: 42px;\n}\n\n.condition .cards h3 {\n    font-size: 25px;\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n\n.condition .cards p {\n    font-size: 18px;\n}\n\n.condition .cards {\n    border-radius: 3px;\n    margin-bottom: 20px;\n}\n\n.condition ul .cards p {\n    margin-bottom: 4px;\n}\n\n.cards ul {\n    padding-left: 0;\n}\n\n.condition {\n    padding: 4rem 0;\n}\n\n.get-start h2 {\n    font-size: 32px;\n    font-weight: 600;\n    margin-bottom: 7px;\n    color: #3C3C3C;\n}\n\n.get-start h3 {\n    font-size: 24px;\n    margin-bottom: 8px;\n    font-weight: 400;\n}\n\n.get-start p {\n    font-size: 18px;\n    color: #4D4D4D;\n}\n\n.registration .rigester-box {\n    background-color: #fff;\n    width: 100%;\n    padding: 70px 30px;\n    border-radius: 20px;\n    margin: auto;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.stapper-box .select-btn.stpe-three button {\n    padding: 6px 36px;\n}\n\n.registration {\n    background-color: #f2f2f7;\n    padding: 2rem;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n}\n\n.rigester-box .input-box a {\n    border: 1px solid #636060;\n    width: 100%;\n    display: flex;\n    height: 50px;\n    align-items: center;\n    margin-bottom: 22px;\n    border-radius: 7px;\n    color: #4A5057;\n    font-size: 17px;\n    font-weight: 600;\n    padding: 0 122px;\n}\n\n.input-box a img {\n    margin-right: 14px;\n}\n\n.rigester-box .next {\n    position: relative;\n    margin-top: 32px;\n    margin-bottom: 32px;\n}\n\n.rigester-box .next h2 {\n    font-size: 25px;\n    font-weight: 400;\n    margin-bottom: 0;\n    text-align: center;\n    position: absolute;\n    top: 0px;\n    left: 45%;\n    background-color: #fff;\n    padding: 0 8px;\n    right: 45%;\n}\n\n.rigester-box .sign-up input {\n    width: 79%;\n    height: 50px;\n    border: 1px solid #4CCD8D;\n    border-radius: 7px;\n    padding-left: 15px;\n}\n\n.rigester-box .sign-up {\n    position: relative;\n}\n\n.check p {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 0;\n    color: #484848d4;\n}\n\n.rigester-box .check {\n    display: flex;\n    align-items: center;\n    margin-top: 32px;\n}\n\n.check a {\n    color: #484848;\n    font-weight: 600;\n}\n\n.rigester-box .get-start {\n    text-align: center;\n}\n\n.get-start span {\n    font-weight: 600;\n}\n\n.rigester-box .open-box a {\n    border: 1px solid #636060;\n    display: flex;\n    height: 64px;\n    align-items: center;\n    border-radius: 7px;\n    color: #636060;\n    font-size: 18px;\n    font-weight: 400;\n    padding: 0 15px;\n}\n\n.stapper-box h2 {\n    font-size: 22px;\n    color: #232323;\n    font-weight: 400;\n    margin-bottom: 12px;\n    text-align: center;\n}\n\n.stapper-box h3 {\n    font-size: 24px;\n    font-weight: 400;\n    text-align: center;\n    color: #232323;\n}\n\n.stapper-box .select-btn button {\n    border: 1px solid #00000059;\n    background-color: transparent;\n    border-radius: 29px;\n    padding: 6px 24px;\n    margin: 8px 3px;\n    font-size: 14px;\n    color: #313131;\n    font-weight: 500;\n}\n\n.stapper-box .select-btn {\n    margin-top: 40px;\n    text-align: center;\n}\n\n.stapper-box .next-step {\n    position: absolute;\n    top: -7.7rem;\n}\n\n.next-step p {\n    color: #707070;\n    font-size: 16px;\n}\n\n.stapper-box button.next-btn {\n    background-color: #4CCD8D;\n    height: 43px;\n    width: 120px;\n    border: 1px solid #4CCD8D;\n    color: #fff;\n    transition: 0.5s;\n    text-transform: capitalize;\n    font-size: 18px;\n}\n\n.stapper-box button.back-btn {\n    background-color: transparent;\n    height: 43px;\n    width: 120px;\n    border: 1px solid #4CCD8D;\n    color: #00000091;\n    transition: 0.5s;\n    text-transform: capitalize;\n    font-size: 18px;\n}\n\n.stapper-box span svg.MuiSvgIcon-root {\n    width: 35px;\n    height: 35px;\n}\n\n.get-start-login h2 {\n    font-size: 32px;\n    font-weight: 600;\n}\n\n.get-start-login p {\n    font-size: 20px;\n}\n\n.tasti-slide .slick-next:before,\n.tasti-slide .slick-prev:before {\n    color: #fff;\n    opacity: 1;\n    font-family: inherit;\n    font-size: 28px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    bottom: 3px;\n}\n\n.tasti-slide button.slick-arrow {\n    background-color: #1A1D84;\n    width: 46px;\n    height: 46px;\n    border-radius: 50px;\n}\n\n.login .get-start-login a {\n    color: #000;\n    font-weight: 600;\n}\n\n.login .form-group label {\n    font-size: 17px;\n    color: #4A5057;\n    margin-bottom: 2px;\n}\n\n.login .form-group input {\n    border: 1px solid #ccc;\n    width: 100%;\n    display: flex;\n    height: 42px;\n    border-radius: 7px;\n    color: #4a5057ad;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 14px;\n}\n\n.forget a {\n    color: #548CFF;\n    font-weight: 500;\n}\n\n.stapper-box .select-btn.stpe-three {\n    width: 80%;\n    margin: 34px auto 0;\n}\n\n.stapper-box .MuiBox-root.css-hsr0i9 {\n    padding-top: 50px;\n}\n\n.forget {\n    text-align: end;\n}\n\n.login.rigester-box .check {\n    margin-top: 4px;\n}\n\n.login .sec-btns a {\n    background-color: #4CCD8D;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    border-radius: 5px;\n    border: none;\n    width: 300px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.rigester-box.login .input-box {\n    margin: auto;\n    width: 300px;\n}\n\n.rigester-box.login .input-box a {\n    padding: 0 26px;\n}\n\n.sending-mess p {\n    color: #4A5057;\n    font-size: 16px;\n    font-weight: 400;\n    margin-bottom: 2px;\n}\n\n.sending-mess {\n    margin-top: 26px;\n    text-align: center;\n}\n\n.mail-box .sec-btns a {\n    background-color: #4CCD8D;\n    color: #fff;\n    font-size: 18px;\n    border-radius: 5px;\n    border: none;\n    width: 300px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.mail-box img {\n    width: 116px;\n    margin-bottom: 15px;\n}\n\n.mail-box .get-start-login {\n    text-align: center;\n}\n\n.dashfaq .accordion .card-header.collapsed:after {\n    content: \"❯\";\n    font-size: 20px;\n    transform: rotate(360deg);\n    transition: all 0.35s ease 0s;\n    position: absolute;\n    right: 12px;\n    top: 10px;\n    color: #548CFF;\n}\n\n.dashfaq .accordion .card-header:after {\n    content: \"❯\";\n    font-size: 20px;\n    transform: rotate(90deg);\n    transition: all 0.35s ease 0s;\n    position: absolute;\n    right: 12px;\n    top: 10px;\n    color: #548CFF;\n}\n\n.dashfaq .card-header,\n.dashfaq .faqs .card-body {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.dashfaq .faq-acc {\n    padding: 0;\n}\n\n.dashfaq .sec-head {\n    text-align: left;\n}\n\n.dashfaq {\n    padding: 5rem 0;\n}\n\n.faq-acc a.see {\n    color: #2E2E2E;\n    font-size: 20px;\n    font-weight: 500;\n    display: flex;\n    justify-content: end;\n    margin-top: 22px;\n}\n\n.react-switch-bg .year {\n    right: 18px;\n    position: absolute;\n    color: #fff;\n    top: 4px;\n}\n\n.react-switch-bg .mont {\n    left: 9px;\n    position: absolute;\n    color: #fff;\n    top: 4px;\n}\n\n.react-switch-handle {\n    width: 28px !important;\n    height: 28px !important;\n    top: 3px !important;\n    left: 3px;\n}\n\n.pricing-table table {\n    width: 100%;\n}\n\n.pricing-table h3 {\n    font-size: 24px;\n}\n\n.pricing-table p {\n    color: #696868;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.plan button {\n    color: #4CCD8D;\n    border: 1px solid;\n    background-color: transparent;\n    width: 180px;\n    height: 50px;\n    border-radius: 5px;\n    margin-top: 22px;\n}\n\n.pricing-table .plan {\n    width: 90%;\n}\n\n.pricing-table .yearly .start-btn a {\n    width: 180px;\n    height: 50px;\n    margin-top: 0;\n    font-weight: 400;\n    font-size: 18px;\n}\n\n.pricing-table .yearly .start-btn {\n    margin-top: 18px;\n    display: flex;\n    justify-content: center;\n}\n\n.pricing-table table th.w-250px {\n    padding: 20px 16px 0px 16px;\n    border: 1px solid #00000040;\n    width: 250px;\n}\n\n.pricing-table .amount h2 {\n    font-size: 31px;\n    margin-top: 13px;\n}\n\n.pricing-table table td {\n    padding: 13px;\n    border: 1px solid #00000040;\n    color: #363853;\n}\n\n.pricing-table .table-sec {\n    padding: 12px;\n    text-align: center;\n    color: #696868;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.pricing-table td span {\n    border-bottom: 1px solid #2E2E2E;\n    border-block-style: dotted;\n    border-top: 0;\n    color: #696868;\n}\n\n.pricing-table th.top-fixed {\n    /* position: sticky; */\n    top: 85px;\n    background: #fff;\n}\n\n#masthead.back {\n    position: fixed;\n    z-index: 99999;\n    width: 100%;\n    top: 0px;\n    left: 0px;\n    background: #fff;\n    box-shadow: 0px 0px 10px #ccc;\n    animation: animate forwards 1s;\n}\n\n.rigester-box .sign-up a {\n    height: 50px;\n    border: none;\n    top: 0;\n    background-color: #4CCD8D;\n    width: 150px;\n    position: absolute;\n    right: 0;\n    border-radius: 7px;\n    font-size: 18px;\n    color: #fff;\n    font-weight: 500;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n.sucess-modal .next-btn a {\n    background-color: #4ccd8d;\n    color: #fff;\n    padding: 12px 74px;\n    font-size: 18px;\n    border-radius: 5px;\n}\n\n.sucess-modal .next-btn {\n    text-align: center;\n    margin-top: 46px;\n}\n\n.sucess-image img {\n    width: 203px;\n}\n\n.stapper-box .select-btn button.active {\n    background-color: #4ccd8d;\n    border: 1px solid #4ccd8d;\n    color: #fff;\n}\n\n.stapper-box .MuiBox-root span.MuiStepLabel-label {\n    display: none;\n}\n\n.registration .logo h2 {\n    text-align: center;\n    margin-bottom: 26px;\n    font-size: 36px;\n}\n\n.left-sec .get-start {\n    text-align: center;\n    width: 86%;\n    margin: 0;\n}\n\n.registration .left-sec {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.statistics-sec {\n    padding: 0 0 6rem 0;\n}\n\n.statistics-sec h3 {\n    font-size: 36px;\n    font-family: 'Roca Two';\n    text-align: center;\n    margin-bottom: 3rem;\n}\n\n.stats-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n}\n\n.stats-container .stats-count {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.stats-container .stats-count h2{\n    color: #4ccd8d;\n    font-size: 50px;\n    font-weight: 600;\n}\n\n.stats-container .mid-count{\n    border-right: 2px solid #4ccd8d;\n    border-left: 2px solid #4ccd8d;\n}\n\n\n@keyframes animate {\n    0% {\n        top: -100px;\n    }\n\n    100% {\n        top: 0px;\n    }\n}\n\n\n/* =====responsive====== */\n\n@media (max-width:1366px) {}\n\n@media (max-width:1280px) {\n    .menubar .logo a {\n        font-size: 22px;\n    }\n    .rigester-box .input-box a {\n        padding: 0 100px;\n    }\n}\n\n@media (max-width:2048px) {}\n\n@media (max-width:1080px) {\n    .menubar .logo {\n        padding-right: 0;\n    }\n\n    .menubar .logo a {\n        font-size: 20px;\n    }\n}\n\n@media (max-width:1024px) {\n    .navbar-nav .nav-item a {\n        font-size: 15px;\n    }\n\n    .menubar .logo a {\n        font-size: 18px;\n    }\n}\n\n@media (max-width:990px) {\n    .header-menu .sec-center {\n        position: relative;\n    }\n\n    .page button.navbar-toggler {\n        position: absolute;\n        right: 0;\n        top: 10px;\n    }\n\n    div#navbarNavDropdown {\n        position: absolute;\n        top: 56px;\n        width: 100vw;\n        right: -15px;\n        z-index: 1;\n        box-shadow: 0 9px 10px 0px #d5d1d1;\n        background-color: #fff;\n        padding: 16px 16px 45px 18px;\n    }\n\n    .page .nav-pages {\n        width: 100%;\n        min-width: 100%;\n    }\n\n    .page .but-right {\n        justify-content: flex-start;\n        margin-top: 20px;\n    }\n\n    .menubar .logo a {\n        width: 201px;\n        display: flex;\n        font-size: 22px;\n    }\n\n    .page button.navbar-toggler {\n        top: -3px;\n    }\n\n    .page .but-right {\n        margin-left: 16px;\n    }\n\n    .get-in-touch .contact-form {\n        padding: 30px;\n        /* width: 95%; */\n    }\n\n}\n\n@media (max-width:767px) {\n    .banner-content h2 {\n        font-size: 32px;\n        line-height: 42px;\n    }\n\n    .banner-content p {\n        font-size: 16px;\n        line-height: inherit;\n    }\n\n    .banner-content .green-btn a {\n        padding: 13px 66px;\n        font-size: 16px;\n    }\n\n    .three-card .card-box {\n        margin-bottom: 30px;\n    }\n\n    .sec-head h3.roco-font {\n        font-size: 32px;\n    }\n\n    .sec-head p {\n        font-size: 16px;\n        line-height: inherit !important;\n    }\n\n    .stap .num {\n        font-size: 32px;\n    }\n\n    .stap h3 {\n        font-size: 28px;\n        line-height: 39px;\n    }\n\n    .stap p {\n        font-size: 16px;\n        line-height: inherit !important;\n    }\n\n    .how-to-work .step-arrow img {\n        display: none;\n    }\n\n    .how-to-work .images img {\n        width: 100%;\n    }\n\n    .simple-pricing .yearly {\n        margin-bottom: 30px;\n    }\n\n    .how-to-work .step-arrow {\n        margin-bottom: 30px;\n    }\n\n    .get-in-touch .contact-form {\n        padding: 36px 24px;\n        width: 100%;\n        position: initial;\n    }\n\n    .get-in-touch {\n        margin-bottom: 4rem;\n    }\n\n    .tasti-slide button.slick-arrow {\n        width: 38px;\n        height: 38px;\n        border-radius: 50px;\n        top: 80px;\n    }\n\n    .tasti .text p {\n        font-size: 16px;\n    }\n\n    .tasti .text img.left {\n        width: 60px;\n        position: absolute;\n        top: -8px;\n        left: 0px;\n    }\n\n    .tasti .text img.right {\n        width: 60px;\n        position: absolute;\n        top: 162px;\n        right: 0;\n    }\n\n    .tasti .slick-prev {\n        left: 0;\n    }\n\n    .tasti .slick-next {\n        right: 0;\n    }\n\n    .about-content h3 {\n        font-size: 28px;\n        line-height: initial;\n    }\n\n    .about-content p {\n        font-size: 16px;\n    }\n\n    .about-us {\n        padding-top: 0;\n    }\n\n    .contact-form h2 {\n        font-size: 32px;\n        margin-bottom: 32px;\n    }\n\n    .main-footer .footer-logo h2 {\n        font-size: 36px;\n    }\n\n    .main-footer .footer-page ul {\n        padding-left: 15px;\n        column-count: 1;\n        margin-top: 10px;\n    }\n\n    .main-footer .footer-page li {\n        margin-bottom: 14px;\n    }\n\n    .header-menu nav.navbar {\n        padding: 0;\n    }\n\n    .page button.navbar-toggler {\n        top: -36px;\n        padding: 2px 7px;\n    }\n\n    div#navbarNavDropdown {\n        top: 18px;\n    }\n\n    .registration {\n        height: auto;\n        padding: 2rem 0;\n    }\n\n    .registration .logo h2 {\n        margin-bottom: 16px;\n        font-size: 32px;\n    }\n\n    .get-start h2 {\n        font-size: 28px;\n    }\n\n    .rigester-box.login .input-box a {\n        padding: 0 19px;\n        font-size: 16px;\n        height: 45px;\n    }\n\n    .rigester-box.login .input-box {\n        width: 100%;\n    }\n\n    .login .sec-btns a {\n        width: 100%;\n        height: 45px;\n    }\n\n    .mail-box .sec-btns a {\n        height: 45px;\n        width: 100%;\n\n    }\n\n    .rigester-box .input-box a {\n        padding: 11px;\n        height: 45px;\n    }\n\n    .get-start h3 {\n        font-size: 22px;\n    }\n\n    .rigester-box .sign-up a {\n        height: 50px;\n        width: 105px;\n        font-size: 16px;\n        height: 45px;\n    }\n\n    .rigester-box .sign-up input {\n        width: 79%;\n        height: 45px;\n    }\n\n    .rigester-box .next h2 {\n        font-size: 18px;\n        top: 4px;\n        left: 43%;\n    }\n\n    .rigester-box .open-box a {\n        height: 50px;\n        margin-bottom: 20px;\n    }\n\n    .get-start p {\n        font-size: 16px;\n    }\n\n    .stapper-box .select-btn.stpe-three {\n        width: 100%;\n    }\n\n    .css-yefs0x-MuiPaper-root.sucess-modal {\n        width: 95%;\n    }\n\n    .sucess-image img {\n        width: 150px;\n    }\n}\n\n\n.subscription_card {\n    width: 280px;\n    height: 400px;\n    /* border: 1px solid #8e44ad; */\n    transition: box-shadow 0.3s ease;\n}\n\n.subscription_card:hover {\n    box-shadow: 0 0 20px 0 rgba(123, 241, 133, 0.7);\n}\n\n.cad-text-small {\n    font-size: 13px !important;\n}\n\n.cad-text-medium {\n    font-size: 15px !important;\n}\n\n.cad-text-large {\n    font-size: 18px !important;\n}\n\n.cad-text-xlarge {\n    font-size: 22px !important;\n\n}\n\n.cad-fw-100 {\n    font-weight: 100 !important;\n}\n\n.cad-fw-400 {\n    font-weight: 400 !important;\n}\n\n.cad-fw-500 {\n    font-weight: 500 !important;\n}\n\n\n.cad-fw-600 {\n    font-weight: 600 !important;\n}\n\n.cad-fw-700 {\n    font-weight: 700 !important;\n}\n\n.cad-fw-800 {\n    font-weight: 800 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
